import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { IndexComponent } from './index/index.component';
import { AuthGuardService } from './utils/guards/auth-guard.service';

const routes: Routes = [
  { path: '', component: IndexComponent },
  {
    path: 'about',
    loadChildren: () =>
      import('./about/about.module').then(
        m => m.AboutModule
      )
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./login/login.module').then(
        m => m.LoginModule
      )
  },
  {
    path: 'news',
    loadChildren: () =>
      import('./news/news.module').then(
        m => m.NewsModule
      )
  },
  {
    path: 'verify-email/:base64EncodedEmail',
    loadChildren: () =>
      import('./verify-email/verify-email.module').then(
        m => m.VerifyEmailModule
      )
  },
  {
    path: 'email/:base64EncodedEmail/reference/:activation_code',
    loadChildren: () =>
      import('./verify-email-status/verify-email-status.module').then(
        m => m.VerifyEmailStatusModule
      )
  },
  {
    path: 'privacy-policy',
    loadChildren: () =>
      import('./privacy-policy/privacy-policy.module').then(
        m => m.PrivacyPolicyModule
      )
  },
  {
    path: 'terms-conditions',
    loadChildren: () =>
      import('./terms-conditions/terms-conditions.module').then(
        m => m.TermsConditionsModule
      )
  },
  {
    path: 'refund-policy',
    loadChildren: () =>
      import('./refund-policy/refund-policy.module').then(
        m => m.RefundPolicyModule
      )
  },
  {
    path: 'transactions-law',
    loadChildren: () =>
      import('./transaction-law/transaction-law.module').then(
        m => m.TransactionLawModule
      )
  },
  {
    path: 'forget-password',
    loadChildren: () =>
      import('./forget-password/forget-password.module').then(
        m => m.ForgetPasswordModule
      )
  },
  {
    path: 'reset-password/:base64EncodedEmail',
    loadChildren: () =>
      import('./reset-password/reset-password.module').then(
        m => m.ResetPasswordModule
      )
  },
  {
    path: 'change-password',
    loadChildren: () =>
      import('./change-password/change-password.module').then(
        m => m.ChangePasswordModule
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: 'resume',
    loadChildren: () =>
      import('./resume/resume.module').then(
        m => m.ResumeModule
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: 'alert',
    loadChildren: () => 
      import('./alert/alert.module').then(
        m => m.AlertModule
      ),
  },
  {
    path: 'contact',
    loadChildren: () => 
      import('./contact-us/contact-us.module').then(
        m => m.ContactUsModule
      ),
  },
  {
    path: 'japanese-manners',
    loadChildren: () => 
      import('./japanese-manner/japanese-manner.module').then(
        m => m.JapaneseMannerModule
      ),
  },
  {
    path: 'partner-services',
    loadChildren: () => 
      import('./services/services.module').then(
        m => m.ServicesModule
      ),
  },
  {
    path: 'profile',
    loadChildren: () => 
      import('./profile/profile.module').then(
        m => m.ProfileModule
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: 'topup',
    loadChildren: () => 
      import('./load-balance/load-balance.module').then(
        m => m.LoadBalanceModule
      ),
    canActivate: [AuthGuardService],
  },
  {
    path: 'transactions',
    loadChildren: () => 
      import('./transaction/transaction.module').then(
        m => m.TransactionModule
      ),
    canActivate: [AuthGuardService],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
